<template>
  <el-dialog :visible='value' title="标的折扣率" width='900px' :show-close='false'>
    <div class="modal-table">
      <p class='clearfix'>
        <span>标的类型</span>
        <span>租期三年及以上收费比例</span>
        <span>租期二年至不满三年收费比例</span>
        <span>租期不满二年收费比例</span>
      </p>
      <p class='clearfix'>
        <span>商铺</span>
        <span>首年首月*0.8</span>
        <span>首年首月*0.7</span>
        <span>首年首月*0.6</span>
      </p>
      <p class='clearfix'>
        <span>住宅</span>
        <span>首年首月*0.3</span>
        <span>首年首月*0.3</span>
        <span>首年首月*0.3</span>
      </p>
      <p class='clearfix'>
        <span>市场</span>
        <span>首年首月*0.8</span>
        <span>首年首月*0.7</span>
        <span>首年首月*0.6</span>
      </p>
      <p class='clearfix'>
        <span>厂房</span>
        <span>首年首月*0.8</span>
        <span>首年首月*0.7</span>
        <span>首年首月*0.6</span>
      </p>
      <p class='clearfix'>
        <span>办公</span>
        <span>首年首月*0.8</span>
        <span>首年首月*0.7</span>
        <span>首年首月*0.6</span>
      </p>
      <p class='clearfix'>
        <span>土地</span>
        <span>首年首月*0.8</span>
        <span>首年首月*0.7</span>
        <span>首年首月*0.6</span>
      </p>
      <p class='clearfix'>
        <span>场地</span>
        <span>首年首月*0.8</span>
        <span>首年首月*0.7</span>
        <span>首年首月*0.6</span>
      </p>
      <p class='clearfix'>
        <span>农用地</span>
        <span>首年首月*0.8</span>
        <span>首年首月*0.7</span>
        <span>首年首月*0.6</span>
      </p>
      <p class='clearfix'>
        <span>商业</span>
        <span>首年首月*0.8</span>
        <span>首年首月*0.7</span>
        <span>首年首月*0.6</span>
      </p>
      <p class='clearfix'>
        <span>其他</span>
        <span>首年首月*0.8</span>
        <span>首年首月*0.7</span>
        <span>首年首月*0.6</span>
      </p>

    </div>
    <template slot="footer">
      <el-button key="back" @click="handleCancel">
        确定
      </el-button>
    </template>
  </el-dialog>
</template>

<script>
  export default {
    name: "discountRate",
    props:['value'],
    components: {},
    data() {
      return {}
    },
    methods: {
      handleCancel(){
        this.$emit('input', false)
      },
    },
    created() {

    },
  }
</script>

<style scoped lang="scss">
  .modal-table {
    border-top: 1px solid #a0a0a0;
    border-left: 1px solid #a0a0a0;
    p {
      margin: 0;
      &:first-child{
        font-weight: 700;
      }
      span {
        border-right: 1px solid #a0a0a0;
        border-bottom: 1px solid #a0a0a0;
        line-height: 35px;
        height: 35px;
        font-size: 14px;
        display: block;
        float: left;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
        padding-left: 20px;
        text-align: center;
        width: 28.65%;
        &:first-child{
          width: 14%;
        }
      }
    }
  }
</style>
